import { Box } from '@mui/material'
import React from 'react'

const WizardContainer = ({ children, sx }) => {
  return (
    <Box
      sx={{
        maxWidth: '750px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        ...sx,
      }}
    >
      {children}
    </Box>
  )
}

export default WizardContainer
